import { apiRequest } from "@/api";
import { ENDPOINTS } from "@/api/endpoints";
import type { FilterOption } from "./filter-options.types";

// Shared GET → { id, name }[] helper for the list endpoints, optionally scoped
// by the selected traffic providers (mirrors the React `trafficProvider` query
// repeated per id).
async function fetchOptionList(path: string, providerIds?: number[]): Promise<FilterOption[]> {
  const [data, error] = await apiRequest<FilterOption[]>({
    method: "GET",
    path,
    queries: providerIds?.length ? { trafficProvider: providerIds } : undefined,
  });
  if (error) throw new Error(error);
  return data ?? [];
}

export function fetchCampaignList(providerIds?: number[]): Promise<FilterOption[]> {
  return fetchOptionList(ENDPOINTS.getCampaignList, providerIds);
}

export function fetchOfferList(providerIds?: number[]): Promise<FilterOption[]> {
  return fetchOptionList(ENDPOINTS.getOfferList, providerIds);
}

export function fetchTriggerList(providerIds?: number[]): Promise<FilterOption[]> {
  return fetchOptionList(ENDPOINTS.getTriggerList, providerIds);
}

// Creatives aren't scoped by traffic providers.
export function fetchCreativeList(): Promise<FilterOption[]> {
  return fetchOptionList(ENDPOINTS.getCreativeList);
}

// "Тип отправки" — not scoped by traffic providers.
export function fetchMailingTypeList(): Promise<FilterOption[]> {
  return fetchOptionList(ENDPOINTS.getMailingTypeList);
}
